export default __webpack_public_path__ + "static/media/text.png?.89af1b03";